<template>
  <div id="batchtrack" class="mx-2">
    <div class="growth_list bg-white shadow-md batch-list-hover flex flex-col h-full">
      <div class="growth_title flex items-center mb-3">
        <p class="font-bold text-xl text-dark">
          {{ trackTitle }}
        </p>
        <span>
          <vx-tooltip :text="board.boardIcon && board.boardIcon.toolTipNote">
            <feather-icon :icon="board.boardIcon && board.boardIcon.icon" svgClasses="" class="ml-3 h-5 w-5 mt-3" />
          </vx-tooltip>
        </span>
      </div>
      <vue-perfect-scrollbar
        class="plants flex-grow h-full"
        :settings="{
          wheelPropagation: true,
          minScrollbarLength: 0.6,
          wheelSpeed: 0.6
        }"
      >
        <div class="batch_options">
          <batch-track-item :trackItem="item" v-for="(item, i) in trackItems" :key="i" :board="board" :isArchievedList="isArchievedList" />
        </div>
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BatchTrackItem from '@/views/batches/components/BatchTrackItem'

export default {
  name: 'BatchTrack',

  props: {
    trackTitle: {
      type: String,
      default: null
    },

    trackItems: {
      type: Array,
      default: () => []
    },

    board: {
      type: Object,
      default: null
    },

    isArchievedList: {
      type: Boolean,
      default: false
    }
  },

  components: {
    VuePerfectScrollbar,
    BatchTrackItem
  },

  data: () => ({
    loading: false,
    order: [],
    length: 15,
    page: 1,
    search: '',
    batch_boards: []
  })
}
</script>

<style lang="scss" scoped>
#batchtrack {
  .growth_list {
    max-height: calc(100vh - 21rem);
    padding: 10px 5px;
    border-radius: 10px;
    overflow: hidden;

    .batch_options {
      margin-top: 15px;
    }

    &.batch-list-hover {
      border: 2px solid transparent;
      &:hover {
        border: 2px solid #28c76f;
      }
    }
  }
}
</style>
